import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrandInfo } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/BrandInfo";
import { brandInfoProductTileAdaptor } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/brandInfoUtils";
import { DebugInfoSection } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/DebugInfoSection/DebugInfoSection";
import { SearchProductImageClient } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/search/SearchProductImageClient";
import { PriceWithClientFormatMoney } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/PriceText/PriceWithClientFormatMoney";
import { ProductName } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/ProductName";
import { SearchProductLink } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductLink/SearchProductLink";
import { SearchProductTileClickProvider } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/search/SearchProductTileClickProvider";
import { ProductTileContainer } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileContainer/ProductTileContainer";
import { ProductTileTrackingWrapper } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileTrackingWrapper/ProductTileTrackingWrapper";
import { ProductTileUpperContainer } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileUpperContainer/ProductTileUpperContainer";
import { TopBadges } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TopBadges/TopBadges";
import { ProductTileContextProvider } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/ProductTileContextProvider";
import { ProductTileSwatches } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/ProductTileSwatches";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
export var LoggedOutSearchProductTile = function(param) {
    var data = param.data;
    var _productTile_product, _productTile_product1;
    var productTileImageProps = data.productTileImageProps, productTileTrackingWrapperProps = data.productTileTrackingWrapperProps, productTileDebugInfoProps = data.productTileDebugInfoProps, productTileTopBadgesProps = data.productTileTopBadgesProps, productTileClickProviderProps = data.productTileClickProviderProps, productTile = data.productTile, brand = data.brand, priceTextProps = data.priceTextProps, insiderBadgeProps = data.insiderBadgeProps, productSearchString = data.productSearchString;
    var token = (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token;
    if (!token) {
        return null;
    }
    var brandInfoData = brandInfoProductTileAdaptor({
        productTile: productTile,
        productSearchString: productSearchString,
        brand: brand,
        insiderBadgeProps: insiderBadgeProps,
        isLoggedInRetailer: false
    });
    var _productTile_product_name;
    return /*#__PURE__*/ _jsx(ProductTileContextProvider, {
        brandToken: brand === null || brand === void 0 ? void 0 : brand.token,
        brand: brand,
        children: /*#__PURE__*/ _jsx(ProductTileTrackingWrapper, {
            data: productTileTrackingWrapperProps,
            children: /*#__PURE__*/ _jsx(SearchProductTileClickProvider, {
                data: productTileClickProviderProps,
                children: /*#__PURE__*/ _jsxs(ProductTileContainer, {
                    children: [
                        /*#__PURE__*/ _jsxs(ProductTileUpperContainer, {
                            children: [
                                /*#__PURE__*/ _jsx(SearchProductLink, {
                                    data: productTileClickProviderProps,
                                    children: /*#__PURE__*/ _jsx(SearchProductImageClient, {
                                        data: productTileImageProps
                                    })
                                }),
                                /*#__PURE__*/ _jsx(TopBadges, {
                                    data: productTileTopBadgesProps
                                }),
                                /*#__PURE__*/ _jsx(DebugInfoSection, {
                                    data: productTileDebugInfoProps
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: {
                                mobileAndAbove: "1x",
                                tabletAndAbove: 12
                            }
                        }),
                        /*#__PURE__*/ _jsxs(SearchProductLink, {
                            data: productTileClickProviderProps,
                            children: [
                                /*#__PURE__*/ _jsx(ProductName, {
                                    productName: (_productTile_product_name = productTile === null || productTile === void 0 ? void 0 : (_productTile_product1 = productTile.product) === null || _productTile_product1 === void 0 ? void 0 : _productTile_product1.name) !== null && _productTile_product_name !== void 0 ? _productTile_product_name : ""
                                }),
                                /*#__PURE__*/ _jsx(PriceWithClientFormatMoney, _object_spread({}, priceTextProps)),
                                /*#__PURE__*/ _jsx(ProductTileSwatches, {
                                    optionDetails: productTile.options_details
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(BrandInfo, {
                            data: brandInfoData
                        })
                    ]
                })
            })
        })
    });
};
